var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRgbppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    className: "w_40px h_40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__b)",
    fillRule: "evenodd",
    d: "M37.603 7.13a5.393 5.393 0 0 1-3.814 6.606L2.532 22.11A5.393 5.393 0 0 1-.259 11.692l31.256-8.375a5.393 5.393 0 0 1 6.606 3.813",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__c)",
    fillRule: "evenodd",
    d: "M5.713 35.236a5.393 5.393 0 0 1 0-7.627L28.594 4.728a5.393 5.393 0 1 1 7.627 7.627L13.34 35.236a5.393 5.393 0 0 1-7.627 0",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo_svg__d)",
    fillRule: "evenodd",
    d: "M22.622 44.993a5.393 5.393 0 0 1-3.814-6.606l8.375-31.256a5.393 5.393 0 0 1 10.42 2.791L29.226 41.18a5.393 5.393 0 0 1-6.605 3.813",
    clipRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 32.389,
    x2: 1.132,
    y1: 8.51,
    y2: 16.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3674F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3674F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__c",
    x1: 32.419,
    x2: 9.538,
    y1: 8.553,
    y2: 31.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38E539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38E539",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 32.409,
    x2: 24.034,
    y1: 8.531,
    y2: 39.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0166FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgbppLogo);
export default __webpack_public_path__ + "static/media/rgbpp_logo.232ac097a2fb3392c1c8bb97a94f6492.svg";
export { ForwardRef as ReactComponent };